import React, { useState, useEffect } from 'react';
import ComprehensiveDashboard from './ComprehensiveDashboard';

const DashboardSection = ({ 
  clients, 
  onSelectClient, 
  onNavigateToSection,
  currentUser,
  permissions 
}) => {
  return (
    <ComprehensiveDashboard
      clients={clients}
      onSelectClient={onSelectClient}
      onNavigateToSection={onNavigateToSection}
      currentUser={currentUser}
      permissions={permissions}
    />
  );
};

export default DashboardSection;
